import { Component, Input, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { IClaim, IServiceLine } from '@app/private/claims/models/claim.interface';
import { CostcoClaimSummaryConstants } from '@app/constants/costco-claim-summary.constants';
import { luhnCalculate, luhnValidate } from '@app/shared/helpers/luhn-algorithm';
import JsBarcode from 'jsbarcode';

@Component({
    selector: 'app-claim-summary-body',
    templateUrl: './claim-summary-body.component.html',
    styleUrls: ['./claim-summary-body.component.scss', '../costco-claim-summary.component.scss'],
    standalone: false
})
export class ClaimSummaryBodyComponent implements OnInit, AfterViewInit {
  @Input() claim: IClaim;

  @ViewChild('barcode', { static: false })
  barcodeElement!: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.renderBarcode();
  }

  renderBarcode(): void {
    JsBarcode(this.barcodeElement.nativeElement, this.sku, {
      format: 'ITF',
      displayValue: true,
      fontSize: 24
    });
  }

  public get relationship(): string {
    const relationToSubscriber = this.claim.patient.relationToSubscriber;
    return relationToSubscriber && relationToSubscriber.toUpperCase() === 'MEMBER' ? 'Self' : 'Dependent';
  }

  public get totalCharges(): number {
    return (this.claim.serviceLines as []).reduce((previous, current: IServiceLine) => {
      return previous + current.billedAmount;
    }, 0);
  }

  public get vspPays(): number {
    return this.totalCharges - Number(this.claim.patientPaymentAmount || 0);
  }

  public get sku(): string {
    const skuId = '710';
    const skuMiddle = this.createSKUMiddle(this.claim.trackingNumber);
    const skuCheckDigit = luhnCalculate(skuId + skuMiddle);
    const fullSku = skuId + skuMiddle + skuCheckDigit;

    return luhnValidate(fullSku) ? fullSku : null;
  }

  public getServiceCategory(code: string, modifierCodes: string[]): string {

    // since modifierCodes[] might have one or more null values,
    // we filter out the null values and take the first non-null value as the modifier.
    const modifier: string | null = modifierCodes?.filter(code => code != null)[0] ?? null;

    const serviceCategory = CostcoClaimSummaryConstants.serviceCategory[code];

    if (typeof serviceCategory === 'string') {
      return serviceCategory;
    }

    if (modifier && serviceCategory?.[modifier]) {
      return serviceCategory[modifier];
    }

    return serviceCategory?.default;
  }

  public getServiceType(code: string, modifierCodes: string[]): string {
    // since modifierCodes[] might have one or more null values,
    // we filter out the null values and take the first non-null value as the modifier.
    const modifier: string | null = modifierCodes?.filter(code => code != null)[0] ?? null;

    const serviceType = CostcoClaimSummaryConstants.serviceType[code];

    if (typeof serviceType === 'string') {
      return serviceType;
    }

    if (modifier && serviceType?.[modifier]) {
      return serviceType[modifier];
    }

    return serviceType?.default;
  }

  private createSKUMiddle(trackingNumber): string {
    const YY = new Date().getFullYear().toString().substr(-2);
    const MM = ('0' + (new Date().getMonth() + 1)).slice(-2);
    return YY + MM + trackingNumber;
  }
}
